__turbopack_context__.v({
  "sidebar": "u2h_nW_sidebar",
});
